import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import OperatingRoom from '../Classes/OperatingRoom'
import { OperatingRoomDto } from '../Types/OperatingRoomDto'
import Room from '../Classes/ClvrRoom'

export class OperatingRoomApiAdapter implements ApiDataAdapter<OperatingRoom> {
    public createClass(apiData: OperatingRoomDto): OperatingRoom {
        const refRooms = get(apiData, '_rooms')

        return new OperatingRoom(
            get(apiData, 'id'),
            get(apiData, 'group_id'),
            get(apiData, 'nom'),
            get(apiData, 'type'),
            get(apiData, 'days_locked'),
            get(apiData, 'tel'),
            get(apiData, 'fax'),
            get(apiData, 'use_brancardage'),
            get(apiData, 'duree_preop_ambu'),
            get(apiData, 'checklist_everyday'),
            get(apiData, 'actif'),
            Room.convertDtoToRoomList(refRooms),
        )
    }
}
